import { ref, onMounted, nextTick } from 'vue'

export default function() {
  const mounted = ref(false)
  const domContentLoaded = ref(false)

  onMounted(() => {
    mounted.value = true
  })

  nextTick(() => {
    domContentLoaded.value = true
  })

  return {
    // data
    mounted,
    domContentLoaded,
  }
}
